<template>
  <div>
    <b-row class="mainActionsRow text-center mt-2 mx-0 justify-content-center gap-1">
      <b-col
        class="py-sm-3 one-border p-100 action"
        v-bind:class="action.class"
        v-for="(action, idx) in action"
        :class="action.enable ? 'cursor' : 'image-disable'"
        v-bind:key="idx"
        @click="action.enable && $router.push(`${action.router}`)"
      >
        <div class="position-relative">
          <img
            :class="`${action.class}`"
            :src="action.img"
            class="imageStyle material-icons align-middle big-icon mb-2"
            alt="image"
          />
          <label class="m-0 d-block text-center image-label">
            {{ labelText(action) }}
          </label>
        </div>
        <h6 class="m-0 d-block" :class="`${action.class}`">
          {{ action.title }}
        </h6>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    action: Array,
    coinsInfo: Object,
  },
  computed: {
    labelText() {
      return (action) => {
        if (action.title === 'Coins to Approve') return this.coinsInfo.Pending;
        return '';
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.one-border:last-child {
  border-left: 1px solid #f2f2f2;
}
.main-coins .small {
  width: 20px;
}

.mainActionsRow {
  gap: 1rem;
}

.action {
  width: 46% !important;
  background-color: white;
  border-radius: 10px;
  box-shadow: var(--atm-shadow);
}

.imageStyle {
  height: 50px;
}

.image-disable {
  filter: grayscale(100%);
}

.image-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px;
  border-radius: 5px;
  font-weight: bolder;
}
</style>
